module.exports = __webpack_public_path__ + "static/media/sndrec32_15.3caca3dc.ico";